<div class="cliente-atividade">
    <div class="cliente-atividade-header">
        <div class="cliente-atividade-header-block cliente-atividade-header-block-btns">
            <button type="button" class="btn btn-primary mr-2" (click)="insert()">
                <i class="fas fa-plus" aria-hidden="true"></i> Atividade
            </button>
    
            <div class="btn-group">
                <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="d-none d-sm-inline-block">Opções</span>
                </button>
                <div class="dropdown-menu">
                    <a class="dropdown-item" (click)="print()" id="btnPrint">
                        <i class="fas fa-print" aria-hidden="true"></i> Imprimir
                    </a>
                </div>
            </div>
        </div>

        <div class="cliente-atividade-header-block">
            <sgt-atividade-visualizacao
                #visualizacaoComponent
                [visualizacao]="visualizacao"
                (changeModo)="onChangeModoVisualizacao()">
            </sgt-atividade-visualizacao>
        </div>        
    </div>

    <div class="cliente-atividade-filter">
        <sgt-atividade-filter
            #filterComponent
            [filter]="filter"
            (filterInitialized)="onFilterInitialized()"
            (filterChange)="onFilterChange()">
        </sgt-atividade-filter>
    </div>
    
    <div class="cliente-atividade-content">
        <!-- Calendar -->
        <sgt-atividade-calendar
            *ngIf="visualizacaoComponent?.isModoCalendar()"
            #atividadeCalendar
            [filter]="filter"
            (edit)="edit($event)"
            (delete)="delete($event)">
        </sgt-atividade-calendar>   
        
        <!-- List -->        
        <sgt-atividade-list
            *ngIf="visualizacaoComponent?.isModoList()"
            #atividadeList
            [filter]="filter"
            [hiddenColumnCliente]="true"
            (edit)="edit($event)"
            (delete)="delete($event)">
        </sgt-atividade-list>
    </div>    
</div>

<!-- Form Modal -->
<sgt-atividade-form-modal
    #formModal
    [canEditCliente]="false"
    (afterSave)="afterSave()">
</sgt-atividade-form-modal>
